module.exports = __webpack_public_path__ + "img/Slide10_v2.c5dd6688.jpg";